import { render, staticRenderFns } from "./Landing7Faqs.vue?vue&type=template&id=1c355b38&scoped=true&"
import script from "./Landing7Faqs.vue?vue&type=script&lang=js&"
export * from "./Landing7Faqs.vue?vue&type=script&lang=js&"
import style0 from "./Landing7Faqs.vue?vue&type=style&index=0&id=1c355b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c355b38",
  null
  
)

export default component.exports